export const SINGLE_SELECT_FACET_FIELDS = {
  pricingTag: true,
  txAttrFacet_Gender: true,
  zc1: true,
  zc2: true,
  zc3: true,
  zc4: true
} as const;

// Legacy brand facet with granular brand variations (e.g., adidas, adidas Golf, adidas Kids as separate entries)
export const BRAND_FACET = 'brandNameFacet';
// Modern brand facet with consolidated brand groupings (e.g., all adidas variations grouped under adidas)
export const REAL_BRAND_FACET = 'realBrandNameFacet';
